<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal(false)" tabindex="-1" id="ticketSaleModal" aria-labelledby="ticketSaleModalLabel">
    <div class="modal-dialog modal-lg">
      <div v-if="loaded" class="modal-content shadow-none">
        <loader />
      </div>
      <div v-else class="modal-content shadow-none">
        <div class="modal-header p-5">
          <h5 class="modal-title">{{ item?.specCode || saleItem?.spec?.code ? 'Абонемент: ' + (item?.specCode || saleItem.spec.code) : 'Абонемент' }}</h5>
          <div @click="closeModal(false)" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div v-if="specOptions.length" class="col-md-6">
              <div class="custom-select dynamic mb-5">
                <label class="required" for="sale.spec">Абонемент (spec)</label>
                <v-select
                  v-model="item.specCode"
                  input-id="sale.spec"
                  :options="specOptions"
                  :reduce="option => option.code"
                  placeholder="Выберите..."
                  class="bg-gray-100 form rounded"
                  label="label"
                  @option:selected="onSpecSelected"
                />
              </div>
            </div>
            <div class="col-md-3">
              <input-field
                v-model="item.sortOrder"
                id="sale.sortOrder"
                name="sale.sortOrder"
                placeholder="Порядок сортировки"
                type="number"
                mb="5"
              />
            </div>
            <div class="col-md-3">
              <input-field
                v-model="item.specCode"
                id="sale.spec.code"
                name="sale.spec.code"
                placeholder="Код спецификации"
                type="text"
                mb="5"
                disabled
              />
            </div>
            <div class="col-md-6 d-flex align-items-end mb-5">
              <switch-box-field
                v-model="item.isPromo"
                id="sale.isPromo"
                name="sale.isPromo"
                placeholder="Промо-акция"
                mb="5"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input-field
                v-model="item.validFrom"
                id="sale.validFrom"
                name="sale.validFrom"
                placeholder="Доступно с"
                type="datetime-local"
                mb="5"
              />
            </div>
            <div class="col-md-6">
              <input-field
                v-model="item.validTo"
                id="sale.validTo"
                name="sale.validTo"
                placeholder="Доступно до"
                type="datetime-local"
                :min="item.validFrom"
                mb="5"
              />
            </div>
          </div>

          <div class="mb-5">
            <div class="fs-6 fw-bold mb-3">Цена</div>
            <div class="row">
              <div class="col-md-4">
                <currency-field
                  v-model="item.price.value"
                  id="sale.price.value"
                  name="sale.price.value"
                  placeholder="Стоимость"
                  mb="5"
                />
              </div>
              <div v-if="currencyOptions.length" class="col-md-4">
                <div v-if="saleItem && saleItem.id" class="custom-select dynamic mb-5">
                  <label class="required" for="item.price.currency.code">Валюта</label>
                  <v-select
                    v-model="item.price.currency.code"
                    input-id="item.price.currency.code"
                    :options="currencyOptions"
                    :reduce="option => option.code"
                    placeholder="Выберите..."
                    class="bg-gray-100 form rounded"
                    label="label"
                    @option:selected="onCurrencySelected"
                  />
                </div>
                <div v-else class="custom-select dynamic mb-5">
                  <label class="required" for="sale.price.currencyCode">Валюта</label>
                  <v-select
                    v-model="item.price.currencyCode"
                    input-id="sale.price.currencyCode"
                    :options="currencyOptions"
                    :reduce="option => option.code"
                    placeholder="Выберите..."
                    class="bg-gray-100 form rounded"
                    label="label"
                    @option:selected="onCurrencySelected"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <input-field
                  v-model="item.price.color"
                  id="sale.price.color"
                  name="sale.price.color"
                  placeholder="Цвет"
                  type="color"
                  mb="5"
                />
              </div>
            </div>

            <div v-if="isUpdate" class="p-5 rounded border">
              <div class="fs-6 fw-bold mb-3">Лимит</div>
              <div class="row">
                <div class="col-md-4">
                  <input-field
                    v-model="limit.validFrom"
                    id="limit.validFrom"
                    name="limit.validFrom"
                    placeholder="Дата с"
                    type="datetime-local"
                    mb="5"
                  />
                </div>
                <div class="col-md-4">
                  <input-field
                    v-model="limit.validTo"
                    id="limit.validTo"
                    name="limit.validTo"
                    placeholder="Дата до"
                    type="datetime-local"
                    mb="5"
                  />
                </div>
                <div class="col-md-4">
                  <input-field
                    v-model="limit.value"
                    id="limit.value"
                    name="limit.value"
                    placeholder="Лимит"
                    type="number"
                    mb="5"
                  />
                </div>
              </div>
              <div v-if="isUpdate">
                <button :disabled="!(limit.validFrom && limit.validTo && limit.value)" class="btn btn-primary btn-sm" type="button" @click="createLimit(saleId ?? saleItem.id)">Создать</button>
              </div>
            </div>

            <div v-if="false" class="row">
              <div class="col-md-4">
                <input-field
                  v-model="item.price.currency.label"
                  id="sale.price.currency.label"
                  name="sale.price.currency.label"
                  placeholder="Название валюты"
                  type="text"
                  mb="5"
                />
              </div>
              <div class="col-md-4">
                <input-field
                  v-model="item.price.currency.description"
                  id="sale.price.currency.description"
                  name="sale.price.currency.description"
                  placeholder="Описание валюты"
                  type="text"
                  mb="5"
                />
              </div>
              <div class="col-md-4">
                <input-field
                  v-model="item.price.currency.image"
                  id="sale.price.currency.image"
                  name="sale.price.currency.image"
                  placeholder="Изображение (URL)"
                  type="text"
                  mb="5"
                />
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="fs-6 fw-bold mb-3">Переопределение параметров</div>
            <div class="row">
              <div class="col-md-4">
                <input-field
                  v-model="item.overrideNominal"
                  @input="onlyDigits"
                  id="sale.overrideNominal"
                  name="sale.overrideNominal"
                  placeholder="Номинал"
                  mb="5"
                />
              </div>
              <div class="col-md-4">
                <input-field
                  v-model="item.overrideValidityPeriod"
                  @input="onlyDigits"
                  id="sale.overrideValidityPeriod"
                  name="sale.overrideValidityPeriod"
                  placeholder="Срок действия"
                  mb="5"
                />
              </div>
              <div class="col-md-4">
                <div class="custom-select dynamic mb-5">
                  <label class="required" for="ticket.validityPeriodUnit">Единица срока действия</label>
                  <v-select
                    v-model="item.overrideValidityPeriodUnit"
                    input-id="item.overrideValidityPeriodUnit"
                    :options="validityPeriodUnitOptions"
                    :reduce="option => option.value"
                    placeholder="Выберите..."
                    class="bg-gray-100 form rounded"
                    label="label"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-if="item.spec && item.spec.badges && item.spec.badges.length" class="mb-5">
            <div class="fs-6 fw-bold mb-3">Badges из спецификации (spec)</div>
            <div v-for="(badge, index) in item.spec.badges" :key="index" class="border rounded p-3 mb-2 bg-light">
              <div class="row">
                <div class="col-md-6">
                  <div class="fs-7 text-muted mb-1">Код:</div>
                  <div class="fw-bold">{{ badge.code }}</div>
                </div>
                <div class="col-md-6">
                  <div class="fs-7 text-muted mb-1">Значение:</div>
                  <div class="fw-bold">{{ badge.value }}</div>
                </div>
              </div>
              <div v-if="badge.i18n && badge.i18n.length" class="mt-2">
                <div class="fs-7 text-muted mb-1">Локализация:</div>
                <div class="row">
                  <div v-for="i18nItem in badge.i18n" :key="i18nItem.locale" class="col-md-4">
                    <div class="fs-7"><strong>{{ i18nItem.locale }}:</strong> {{ i18nItem.value }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="fs-6 fw-bold">Badges продажи (saleBadges)</div>
              <button class="btn btn-light btn-sm" type="button" @click="addSaleBadge">Добавить</button>
            </div>
            <div v-for="(badge, index) in item.saleBadges" :key="index" class="border rounded p-4 mb-3">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="fw-bold">Значок #{{ index + 1 }}</div>
                <button class="btn btn-icon btn-sm btn-light-danger" type="button" @click="removeSaleBadge(index)">
                  <i class="ki-outline ki-trash fs-5"></i>
                </button>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <input-field
                    v-model="badge.code"
                    :id="`sale.saleBadges.${index}.code`"
                    :name="`sale.saleBadges.${index}.code`"
                    placeholder="Код"
                    type="text"
                    mb="5"
                  />
                </div>
                <div class="col-md-6">
                  <input-field
                    v-model="badge.value"
                    :id="`sale.saleBadges.${index}.value`"
                    :name="`sale.saleBadges.${index}.value`"
                    placeholder="Значение"
                    type="text"
                    mb="5"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <input-field
                    v-model="getI18nItemByLocale(badge.i18n, 'ru-RU', badge).value"
                    :id="`sale.saleBadges.${index}.i18n.ru`"
                    :name="`sale.saleBadges.${index}.i18n.ru`"
                    placeholder="Русский (ru-RU)"
                    type="text"
                    mb="5"
                  />
                </div>
                <div class="col-md-4">
                  <input-field
                    v-model="getI18nItemByLocale(badge.i18n, 'uz-UZ', badge).value"
                    :id="`sale.saleBadges.${index}.i18n.uz`"
                    :name="`sale.saleBadges.${index}.i18n.uz`"
                    placeholder="Узбекский (uz-UZ)"
                    type="text"
                    mb="5"
                  />
                </div>
                <div class="col-md-4">
                  <input-field
                    v-model="getI18nItemByLocale(badge.i18n, 'en-US', badge).value"
                    :id="`sale.saleBadges.${index}.i18n.en`"
                    :name="`sale.saleBadges.${index}.i18n.en`"
                    placeholder="Английский (en-US)"
                    type="text"
                    mb="5"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer p-5 justify-content-between">
          <div>
            <button 
              v-if="isUpdate" 
              type="button" 
              @click="deleteTicket" 
              :disabled="saving"
              class="btn btn-danger btn-sm me-2"
            >
              {{ saving ? 'Удаление...' : 'Удалить' }}
            </button>
            <button type="button" @click="closeModal(false)" class="btn btn-light btn-sm">Закрыть</button>
          </div>
          <div>
            <button 
              v-if="isUpdate" 
              type="button" 
              @click="updateTicket" 
              :disabled="saving"
              class="btn btn-primary btn-sm"
            >
              {{ saving ? 'Обновление...' : 'Обновить' }}
            </button>
            <button 
              v-else 
              type="button" 
              @click="createTicket" 
              :disabled="saving"
              class="btn btn-primary btn-sm"
            >
              {{ saving ? 'Создание...' : 'Создать' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import InputField from '@/components/Fields/InputField'
import CurrencyField from '@/components/Fields/CurrencyField'
import SwitchBoxField from '@/components/Fields/SwitchBoxField'
import vSelect from 'vue-select'
import { notify } from '@kyvg/vue3-notification'
import axios from 'axios'

const defaultLocales = ['ru-RU', 'uz-UZ', 'en-US']

const defaultCurrencyTemplate = () => ({
  code: null,
  label: null,
  description: null,
  image: null,
  i18n: defaultLocales.map(locale => ({
    locale,
    label: null,
    description: null,
    image: null
  }))
})

const defaultSaleBadge = () => ({
  code: null,
  value: null,
  i18n: defaultLocales.map(locale => ({
    locale,
    value: null
  }))
})

const defaultItem = () => ({
  id: null,
  validFrom: null,
  validTo: null,
  isPromo: false,
  price: {
    value: 0,
    currencyCode: null,
    currency: defaultCurrencyTemplate(),
    color: null
  },
  saleBadges: [defaultSaleBadge()],
  sortOrder: 100, // По умолчанию 100 согласно схеме
  overrideNominal: null,
  overrideValidityPeriod: null,
  overrideValidityPeriodUnit: null,
  specCode: null,
  spec: null
})

export default {
  name: 'TicketSaleModal',
  components: { Loader, InputField, CurrencyField, SwitchBoxField, vSelect },
  props: {
    saleItem: {
      type: Object,
      default: null
    },
    saleId: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      loaded: false,
      saving: false,
      item: defaultItem(),
      currencies: [],
      specs: [],
      limit: {
        validFrom: null,
        validTo: null,
        value: null,
      }
    }
  },
  computed: {
    isUpdate() {
      return !!(this.saleId || (this.saleItem && this.saleItem.id) || this.item?.id)
    },
    currencyOptions() {
      if (!this.currencies || !Array.isArray(this.currencies)) return []
      return this.currencies
        .filter(option => option && option.code)
        .map(option => {
          const code = option.code || ''
          const description = option.description || option.label || option.title || ''
          const label = code && description ? `(${code}) ${description}` : (code || description || '')
          return { ...option, label }
        })
    },
    specOptions() {
      if (!this.specs || !Array.isArray(this.specs)) return []
      return this.specs
        .filter(spec => spec && spec.code)
        .map(spec => ({
          ...spec,
          label: spec.label?.value ? `${spec.label.value} (${spec.code})` : spec.code
        }))
    },
    validityPeriodUnitOptions() {
      return [
        { value: 'MINUTES', label: 'Минуты (MINUTES)' },
        { value: 'HOURS', label: 'Часы (HOURS)' },
        { value: 'DAYS', label: 'Дни (DAYS)' }
      ]
    }
  },
  mounted() {
    this.fetchCurrencies()
    this.fetchSpecs()
    setTimeout(() => {
      const modal = document.getElementById('ticketSaleModal')
      if (modal) {
        modal.addEventListener('mousedown', (event) => {
          if (event.target.classList.contains('modal')) this.closeModal()
        })
      }
    }, 10)
  },
  methods: {
    onlyDigits(e) {
      const cleaned = e.target.value.replace(/\D+/g, '')
      this.val = cleaned
      e.target.value = cleaned
    },
    closeModal(isUpdate) {
      bootstrap.Modal.getInstance(document.getElementById('ticketSaleModal')).hide();
      this.$emit('closeModal', isUpdate);
    },
    fetchCurrencies() {
      axios.get('/api/v1/resources/book/items', { params: { catalog: 'currency' } })
        .then(res => {
          this.currencies = res.data?.content || []
        })
        .catch(err => {
          notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message })
        })
    },
    fetchSpecs() {
      axios.get('/api/v1/billing/issuer/tickets/specs', { params: { page: 0, size: 100 } })
        .then(res => {
          this.specs = res.data?.content || []
        })
        .catch(err => {
          notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message })
        })
    },
    fetchSaleData() {
      if (!this.saleId) return
      this.loaded = true
      axios.get(`/api/v1/billing/sale/tickets/${this.saleId}`)
        .then(res => {
          const data = res.data
          // Конвертируем ответ в формат обновления
          const convertedData = this.convertToUpdateFormat(data)
          // Заполняем форму данными
          this.item = {
            ...defaultItem(),
            ...convertedData,
            id: data.id,
            validFrom: convertedData.validFrom ? new Date(typeof convertedData.validFrom === 'string' ? parseInt(convertedData.validFrom) : convertedData.validFrom).toISOString().slice(0, 16) : null,
            validTo: convertedData.validTo ? new Date(typeof convertedData.validTo === 'string' ? parseInt(convertedData.validTo) : convertedData.validTo).toISOString().slice(0, 16) : null,
            isPromo: convertedData.isPromo ?? false,
            sortOrder: convertedData.sortOrder ?? 100,
            price: {
              ...defaultItem().price,
              value: convertedData.price?.value ?? 0,
              currencyCode: convertedData.price?.currencyCode ?? null,
              currency: data.price?.currency ? {
                ...defaultCurrencyTemplate(),
                ...data.price.currency
              } : defaultCurrencyTemplate()
            },
            saleBadges: convertedData.saleBadges && convertedData.saleBadges.length ? convertedData.saleBadges : [defaultSaleBadge()],
            overrideNominal: convertedData.overrideNominal ?? null,
            overrideValidityPeriod: convertedData.overrideValidityPeriod ?? null,
            overrideValidityPeriodUnit: convertedData.overrideValidityPeriodUnit ?? null,
            specCode: data.spec?.code ?? null,
            spec: data.spec ?? null
          }
          this.syncLimitDatesFromItem({ force: true })
        })
        .catch(err => {
          notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message })
        })
        .finally(() => {
          this.loaded = false
        })
    },
    syncLimitDatesFromItem({ force = false } = {}) {
      if (!this.isUpdate) return
      const itemValidFrom = this.item?.validFrom ?? null
      const itemValidTo = this.item?.validTo ?? null

      if (force || this.limit.validFrom === null || this.limit.validFrom === '') {
        this.limit.validFrom = itemValidFrom
      }
      if (force || this.limit.validTo === null || this.limit.validTo === '') {
        this.limit.validTo = itemValidTo
      }
    },
    createLimit(passedId) {
      const id = passedId ?? this.saleId ?? this.saleItem?.id ?? this.item?.id
      if (!id) return

      const toUnixMs = (v) => {
        if (v === null || v === undefined || v === '') return null
        if (typeof v === 'number') return v
        const ms = new Date(v).getTime()
        return Number.isFinite(ms) ? ms : null
      }

      const payload = {
        ...this.limit,
        validFrom: toUnixMs(this.limit.validFrom),
        validTo: toUnixMs(this.limit.validTo),
      }

      axios.post(`/api/v1/billing/issuer/tickets/sale/${id}/inventory`, payload)
        .then(res => {
          if (this.isUpdate) notify({ duration: 7000, type: 'success', speed: 1000, title: 'Успешно', text: 'Лимит создан!' })
          // Сбрасываем поля лимита после успешного создания
          this.limit = { validFrom: null, validTo: null, value: null }
          // Возвращаем дефолтные даты из item (для обновления)
          this.syncLimitDatesFromItem({ force: false })
        })
    },
    convertToUpdateFormat(data) {
      return {
        validFrom: data.validFrom ?? null,
        validTo: data.validTo ?? null,
        isPromo: data.isPromo ?? false,
        sortOrder: data.sortOrder ?? 100, // По умолчанию 100 согласно схеме
        price: {
          value: data.price?.value ?? 0,
          currencyCode: data.price?.currency?.code ?? null
        },
        saleBadges: data.saleBadges && Array.isArray(data.saleBadges) ? data.saleBadges : [],
        overrideNominal: data.overrideNominal ?? null,
        overrideValidityPeriod: data.overrideValidityPeriod ?? null,
        overrideValidityPeriodUnit: data.overrideValidityPeriodUnit ?? null
      }
    },
    onSpecSelected(option) {
      if (!option || !option.code) return
      this.item.specCode = option.code
      this.item.spec = this.specs.find(spec => spec && spec.code === option.code) || null
      if (this.item.specCode) {
        this.item.overrideNominal = this.item.spec.nominal.value ?? null
        this.item.overrideValidityPeriod = this.item.spec.validityPeriod ?? null
        this.item.overrideValidityPeriodUnit = this.item.spec.validityPeriodUnit ?? null
      }
    },
    onCurrencySelected(option) {
      if (!option || !option.code) return
      const selected = this.currencies.find(currency => currency && currency.code === option.code)
      if (selected) {
        this.item.price.currency = {
          code: selected.code || null,
          label: selected.label || null,
          description: selected.description || null,
          image: selected.image || null,
          i18n: selected.i18n?.length ? selected.i18n : defaultCurrencyTemplate().i18n
        }
        // Синхронизируем currencyCode для отправки на сервер
        this.item.price.currencyCode = selected.code || null
      }
    },
    getI18nItemByLocale(i18nArray, locale, parentBadge) {
      if (!i18nArray || !Array.isArray(i18nArray)) {
        if (parentBadge) {
          parentBadge.i18n = defaultLocales.map(loc => ({ locale: loc, value: null }))
          i18nArray = parentBadge.i18n
        } else {
          return { locale, value: null, label: null, description: null, image: null }
        }
      }
      let item = i18nArray.find(item => item && item.locale === locale)
      if (!item) {
        const firstItem = i18nArray[0]
        if (firstItem && ('label' in firstItem || 'description' in firstItem || 'image' in firstItem)) {
          item = { locale, label: null, description: null, image: null }
        } else {
          item = { locale, value: null }
        }
        i18nArray.push(item)
      }
      return item
    },
    normalizeSaleData() {
      if (!this.item.price) this.item.price = { value: 0, currencyCode: null, currency: defaultCurrencyTemplate(), color: null }
      if (!this.item.price.currency) this.item.price.currency = defaultCurrencyTemplate()
      if (!this.item.price.currency.i18n) this.item.price.currency.i18n = defaultCurrencyTemplate().i18n
      if (!this.item.saleBadges || !Array.isArray(this.item.saleBadges) || !this.item.saleBadges.length) {
        this.item.saleBadges = [defaultSaleBadge()]
      } else {
        this.item.saleBadges = this.item.saleBadges.map(badge => ({
          ...badge,
          i18n: badge.i18n && Array.isArray(badge.i18n) && badge.i18n.length ? badge.i18n : defaultSaleBadge().i18n
        }))
      }
    },
    prepareTicketData(isCreate) {
      this.normalizeSaleData()
      
      // Синхронизируем currencyCode из currency.code если currencyCode отсутствует
      if (!this.item.price.currencyCode && this.item.price.currency?.code) {
        this.item.price.currencyCode = this.item.price.currency.code
      }
      
      // Для создания и обновления price содержит только value и currencyCode
      const price = {
        value: this.item.price.value ?? 0,
        currencyCode: this.item.price.currencyCode ?? this.item.price.currency?.code ?? null
      }
      
      const saleBadges = (this.item.saleBadges ?? []).map(badge => ({
        code: badge?.code ?? null,
        value: badge?.value ?? null,
        i18n: (badge?.i18n ?? []).filter(item => item && item.value)
      })).filter(badge => badge && (badge.code || badge.value))
      
      // Для создания: price в конце (после specCode)
      // Для обновления: price перед saleBadges
      if (isCreate) {
        return {
          validFrom: this.item.validFrom ? new Date(this.item.validFrom).getTime() : null,
          validTo: this.item.validTo ? new Date(this.item.validTo).getTime() : null,
          isPromo: Boolean(this.item.isPromo),
          sortOrder: this.item.sortOrder ?? 100,
          saleBadges,
          overrideNominal: this.item.overrideNominal ?? null,
          overrideValidityPeriod: this.item.overrideValidityPeriod ?? null,
          overrideValidityPeriodUnit: this.item.overrideValidityPeriodUnit ?? null,
          specCode: this.item.specCode ?? null,
          price
        }
      }
      
      // Для обновления (id передается в URL, не в теле запроса)
      // Порядок полей соответствует формату обновления из API
      return {
        validFrom: this.item.validFrom ? new Date(this.item.validFrom).getTime() : null,
        validTo: this.item.validTo ? new Date(this.item.validTo).getTime() : null,
        isPromo: Boolean(this.item.isPromo),
        sortOrder: this.item.sortOrder ?? 100,
        price,
        saleBadges,
        overrideNominal: this.item.overrideNominal ?? null,
        overrideValidityPeriod: this.item.overrideValidityPeriod ?? null,
        overrideValidityPeriodUnit: this.item.overrideValidityPeriodUnit ?? null
      }
    },
    validToNotBeforeFrom() {
      if (!this.item.validTo || !this.item.validFrom) return true
      if (this.item.validTo >= this.item.validFrom) return true
      notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: 'Дата «Доступно до» не может быть раньше «Доступно с»' })
      return false
    },
    updateTicket() {
      const id = this.saleId || this.saleItem?.id || this.item?.id
      if (!id) return
      if (!this.validToNotBeforeFrom()) return
      this.saving = true
      const saleData = this.prepareTicketData(false)
      axios.put(`/api/v1/billing/issuer/tickets/sale/${id}`, saleData)
        .then(res => {
          notify({ duration: 7000, type: 'success', speed: 1000, title: 'Успешно', text: 'Продажа обновлена!' })
          this.closeModal(true)
        })
        .catch(err => {
          notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message })
        })
        .finally(() => this.saving = false)
    },
    createTicket() {
      if (!this.validToNotBeforeFrom()) return
      this.saving = true
      const saleData = this.prepareTicketData(true)
      axios.post('/api/v1/billing/issuer/tickets/sale', saleData)
        .then(res => {
          notify({ duration: 7000, type: 'success', speed: 1000, title: 'Успешно', text: 'Продажа создана!' })
          if (this.limit.value && !this.isUpdate) this.createLimit(res.data.id)
          this.closeModal(true)
        })
        .catch(err => {
          notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message })
        })
        .finally(() => this.saving = false)
    },
    deleteTicket() {
      const id = this.saleId || this.saleItem?.id || this.item?.id
      if (!id) return
      if (!confirm('Вы уверены, что хотите удалить эту продажу?')) return
      
      this.saving = true
      axios.delete(`/api/v1/billing/issuer/tickets/sale/${id}`)
        .then(res => {
          notify({ duration: 7000, type: 'success', speed: 1000, title: 'Успешно', text: 'Продажа удалена!' })
          this.closeModal(true)
        })
        .catch(err => {
          notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message })
        })
        .finally(() => this.saving = false)
    },
    addSaleBadge() {
      this.item.saleBadges.push(defaultSaleBadge())
    },
    removeSaleBadge(index) {
      this.item.saleBadges.splice(index, 1)
    }
  },
  watch: {
    saleId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchSaleData()
        }
      }
    },
    saleItem: {
      immediate: true,
      handler(value) {
        // Если есть saleId, данные будут загружены через fetchSaleData
        if (this.saleId) return
        
        if (value) {
          this.item = {
            ...defaultItem(),
            ...value,
            validFrom: value.validFrom ? new Date(value.validFrom).toISOString().slice(0, 16) : null,
            validTo: value.validTo ? new Date(value.validTo).toISOString().slice(0, 16) : null,
            price: {
              ...defaultItem().price,
              ...value.price,
              // Синхронизируем currencyCode из данных или из currency.code
              currencyCode: value.price?.currencyCode || value.price?.currency?.code || null,
              currency: {
                ...defaultCurrencyTemplate(),
                ...(value.price?.currency || {}),
                // Если currencyCode есть, но currency.code нет, устанавливаем его
                code: value.price?.currency?.code || value.price?.currencyCode || null
              }
            },
            saleBadges: value.saleBadges && value.saleBadges.length ? value.saleBadges : [defaultSaleBadge()],
            specCode: value.spec?.code ?? value.specCode ?? null,
            spec: value.spec ?? null
          }
          this.syncLimitDatesFromItem({ force: true })
        } else {
          this.item = defaultItem()
        }
      }
    },
    isUpdate: {
      immediate: true,
      handler(val) {
        if (val) {
          this.syncLimitDatesFromItem({ force: false })
        } else {
          this.limit = { validFrom: null, validTo: null, value: null }
        }
      }
    },
    'item.validFrom'(newVal, oldVal) {
      if (!this.isUpdate) return
      if (this.limit.validFrom === null || this.limit.validFrom === '' || this.limit.validFrom === oldVal) {
        this.limit.validFrom = newVal ?? null
      }
    },
    'item.validTo'(newVal, oldVal) {
      if (!this.isUpdate) return
      if (this.limit.validTo === null || this.limit.validTo === '' || this.limit.validTo === oldVal) {
        this.limit.validTo = newVal ?? null
      }
    },
    'item.price.currency.code'(newVal) {
      // Автоматически синхронизируем currencyCode при изменении currency.code
      if (newVal && this.item.price) {
        this.item.price.currencyCode = newVal
      }
    }
  }
}
</script>

<style scoped>

</style>